<template>
  <div class="home">
    <h1 class="glitch" data-text="Season 13">Season 13</h1>
    <EpisodeCollection
      v-for="(ep, id) in episodes"
      :episode="ep"
      :id="id"
      :key="id"
    />
  </div>
</template>

<script>
// @ is an alias to /src
import { mapActions, mapGetters } from 'vuex';
import EpisodeCollection from '@/components/EpisodeCollection.vue';

export default {
  name: 'home',
  components: {
    EpisodeCollection,
  },
  computed: {
    ...mapGetters({
      episodes: 'episodes/items',
    })
  },
  created() {
    this.findEpisodes({
      query: { season: 13 },
      order: [
        {
          field: 'releaseDate',
          sort: 'desc'
        }
      ]
    });
  },
  methods: {
    ...mapActions({
      findEpisodes: 'episodes/findEpisodes',
    })
  }
};
</script>

<style lang="scss">
</style>
